<script setup lang="ts">
/**
 * Declaration of Non-Beneficial Owner (Not a BO) — M32110
 * · Member → Company 레터 (지분/의결권 20% 미만 + Criteria C–F 통제 없음)
 * · 변수: member_name / member_address / letter_date / company_name / company_registration_no / [[Signers]]
 */
import DeclarationNonBoDocVarField from './DeclarationNonBoDocVarField.vue';
import DeclarationNonBoSigners from './parts/DeclarationNonBoSigners.vue';
</script>

<template>
  <div class="bo-doc">
    <p class="doc-p">
      <DeclarationNonBoDocVarField field-key="member_name" /><br />
      <DeclarationNonBoDocVarField field-key="member_address" />
    </p>

    <p class="doc-p"><b>Date :</b> <DeclarationNonBoDocVarField field-key="letter_date" /></p>

    <p class="doc-p">
      <DeclarationNonBoDocVarField field-key="company_name" /><br />
      Company Registration No. <DeclarationNonBoDocVarField field-key="company_registration_no" /><br />
      Registered Office
    </p>

    <p class="doc-p">Dear Sir/Madam,</p>

    <p class="doc-p"><b>RE: Declaration of Beneficial Ownership Status</b></p>

    <p class="doc-p">
      I hereby declare that I am holding less than 20% of the ordinary shares or voting shares of the Company
      and I do not have control through other means under Criteria C, D, E and F.
    </p>

    <DeclarationNonBoSigners />
  </div>
</template>

<style src="../boNotices/boNoticeDoc.css"></style>
